import resetPasswordSvg from '@/assets/icons/reset-password.svg'
import decorationSvg from '@/assets/images/decoration.svg'
import LogoSvg from '@/assets/images/logo.svg?react'
import SkipLink from '@/components/SkipLink'
import Navbar from '@/layout/Navbar'
import HeadTags from '@/lib/head/HeadTags'
import {HomeRoute, ResetPasswordRoute} from '@/routeRegistry'
import skipTargetProps from '@/utils/a11y/skipTargetProps'

import ResetPasswordStep1 from './components/ResetPasswordStep1/ResetPasswordStep1'
import ResetPasswordStep2 from './components/ResetPasswordStep2/ResetPasswordStep2'
import style from './ResetPassword.module.scss'

export default memo(function ResetPassword() {
  const {token} = ResetPasswordRoute.useSearch()

  const step = token ? 2 : 1

  return (
    <>
      <HeadTags title='Reset password' />
      <SkipLink title='Skip to main content' to='#main-content' />
      <div className={style.SignUpPage}>
        <img src={decorationSvg} className={style.Decoration} alt='' />
        <div className={style.Content}>
          <Navbar withoutLogoOnDesktop transparentBg variant='dark' />
          <div className={style.Logo}>
            <Link to={HomeRoute.fullPath}>
              <LogoSvg title='InnoSearch Home' />
            </Link>
          </div>
          <main className={style.Main} {...skipTargetProps('main-content')}>
            <div className={style.SuccessDecoration}>
              <img src={resetPasswordSvg} alt='' />
            </div>
            <h1 className={style.Heading}>Reset account password</h1>
            {step === 1 && <ResetPasswordStep1 />}
            {step === 2 && <ResetPasswordStep2 token={token} />}
          </main>
        </div>
      </div>
    </>
  )
})
